import MuiCircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';

export const LoadingSpinner = styled('section')(({ minHeight }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  minHeight: minHeight,
}));

export const CircularProgress = styled(MuiCircularProgress)(({ theme }) => ({
  color: theme.palette.blue60.main,
}));
